export const launchScanScript = (sessionId, accessToken, actionId, actionType, onScanFinish) => {
  const renderProperties = {
    "placeholder": true,
    "startButton": true,
    "containerBorderThickness": 1,
    "containerBorderRadius": 3,
    "containerBorderColor": {
      "default": "#000000"
    },
    "frame": true,
    "frameBorderThickness": 3,
    "frameBorderRadius": 20,
    "frameColor": {
      "default": "rgba(255, 255, 255, 1.0)",
      "detected": "rgba(30, 255, 88, 1.0)"
    },
    "overlay": true,
    "overlayPermanent": true,
    "overlayColor": {
      "default": "#ffffff"
    },
    "upperBarColor": {
      "default": "rgba(255, 255, 255, 1.0)"
    },
    "lowerBarColor": {
      "default": "#a2d2ff",
      "error": "#ffccd5"
    },
    "buttonColor": {
      "default": "#a2d2ff"
    },
    "buttonTextColor": {
      "default": "#353535"
    },
    "overlayTransparency": {
      "default": 0.7
    },
    "icons": true,
    "hint": true,
    "hintTextColor": {
      "default": "#353535"
    },
    "hintFontType": "Arial",
    "mirrorPreview": false
  };

  const clientSession = {
    clientAccessToken: accessToken,
    personId: sessionId
  };

  const config = {
    autoDocType: true,
    docType: 1,
    recognitionMode: 1,
    imageOnlyMode: false,
    translitCheck: true,
    glareCheck: true,
    photocopyCheck: true,
    faceCheck: true,
    lang: 'ru',
    render: renderProperties,
    // hints: customTranslations,
    // flowOptions: ["scan", "egov-code"]
  };

  let scanId;

  veridoc.successCallback = (data) => {
    onScanFinish(scanId, actionId, actionType, accessToken);

    veridoc.dispose();
  }

  veridoc.failCallback = error => {
    console.log('scan fail', error);
  }

  veridoc.errorCallback = error => {
    console.log('scan error', error);

    if (error.name === 'ServerAuthorizationError') {
      // window.location.reload();
    }
  }

  veridoc.updateCallback = () => {
  }

  veridoc.setAccessToken(clientSession.clientAccessToken, clientSession.personId);
  veridoc.init('https://services.verigram.ai:8443/s/veridoc/ru/veridoc/', clientSession.clientAccessToken, config)
    .then(() => {
      scanId = veridoc.start();
    })
    .catch((e) => {
      console.log('fail', e);
    });
}

export const launchLivenessScript = (sessionId, accessToken, actionId, actionType, onScanFinish) => {
  const renderProperties = {
    oval: true,
    ovalType: 'contour',
    ovalRingColor: {
      default: "#F5F542",
      actionSuccess: "#00F500",
      actionFailure: "#F50000",
      sessionSuccess: "#00F500",
      sessionFailure: "#F50000",
    },
    ovalWidth: 1.0,

    overlay: true,
    overlayColor: {
      default: "#2F4F4F",
    },
    overlayTransparency: {
      default: 0.55,
    },

    arrow: true,
    arrowColor: {
      default: '#F0F0F0',
    },
    arrowProgressColor: {
      default: '#404040',
    },

    hint: true,
    hintPosition: 'bottom',
    hintTextColor: {
      default: '#C8C9CC',
    },
    hintFontType: 'Arial',
    hintUseProgressiveFontSize: true,
    hintProgressiveFontSizeMultiplier: 1.0,
    hintFontSize: 25,
    hintCloudColor: {
      "default": '#2D312F',
    },

    videoUploadProgressBar: true,
    videoUploadProgressBarColor1: '#FFEA82',
    videoUploadProgressBarColor2: '#eee',
  };

  const config = {
    recordVideo: true,
    videoBitrate: 2500000,
    rotated: false,
    // lang: 'custom',
    lang: 'ru',
    render: renderProperties,
  };

  const clientSession = {
    clientAccessToken: accessToken,
    personId: sessionId
  };


  verilive.successCallback = (data) => {
    onScanFinish(data.session_id, actionId, actionType, accessToken);

    verilive.dispose();
  }

  verilive.init('https://services.verigram.ai:8443/s/verilive/verilive', '', config)
    .then(() => {
      console.log('succ');
      verilive.start(clientSession.clientAccessToken, clientSession.personId);
    })
    .catch((e) => {
      console.log('fail', e);
    });
}
